import { CmsObjectWithDefault } from '@components/Cms/types';

export type ForgotPasswordPhonePanelCmsKey = 'ForgotPasswordTitle' | 'BackToSignIn';

export const ForgotPasswordPhonePanelCmsWithDefault: CmsObjectWithDefault<ForgotPasswordPhonePanelCmsKey> = {
    ForgotPasswordTitle: {
        cmsId: 76310,
        defaultTranslation: 'Forgot password',
    },
    BackToSignIn: {
        cmsId: 67070,
        defaultTranslation: 'Back to sign in',
    },
};
